import { useBreakpointValue } from "@chakra-ui/react";

export const useIsMobile = () => {
  const isMobileBreakpoint = useBreakpointValue({ base: true, md: false });

  return isMobileBreakpoint;
};
